import { Styles, generateClasses } from '@lsy-netline/netline-ui';

export const languageSelectorMenuClasses = generateClasses('LanguageSelectorMenu', [
  'root',
  'paper',
  'menuItem',
  'menuItemFlag',
] as const);

export const languageSelectorMenuMenuItemClasses = generateClasses(
  languageSelectorMenuClasses.menuItem,
  ['selected'] as const,
  true,
);

export const languageSelectorMenuStyles: Styles = ({ theme: { spacing, palette } }) => ({
  [`&.${languageSelectorMenuClasses.root}`]: {
    width: 0,
    height: 0,
    overflow: 'visible',
  },
  [`.${languageSelectorMenuClasses.paper}`]: {
    maxHeight: 'fit-content',
    maxWidth: 'fit-content',
  },
  [`.${languageSelectorMenuClasses.menuItem}`]: {
    [`&.${languageSelectorMenuMenuItemClasses.selected}`]: {
      backgroundColor: palette.primary.main,
    },
  },
  [`.${languageSelectorMenuClasses.menuItemFlag}`]: {
    marginRight: spacing(1.25),
    height: 24,
    width: 24,
  },
});

export const languageSelectorMenuItemClasses = generateClasses('LanguageSelectorMenuItem', ['root', 'arrow'] as const);

export const languageSelectorMenuItemStyles: Styles = () => ({
  [`&.${languageSelectorMenuItemClasses.root}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
    cursor: 'pointer',
  },
});
